<template>
    <div class="template-item-menu" v-click-outside="closeMenu">
        <i class="fa-solid fa-ellipsis-vertical tim-trigger" @click.stop="open = !open"></i>

        <div class="tim-dropdown" v-if="open" @click.stop>
            <div class="tim-option" @click="emitAndClose('rename')">
                <i class="fa-solid fa-pencil"></i>
                {{ $t('dash.templates.rename') }}
            </div>

            <template v-if="movable">
                <div class="tim-option" @click="showMoveList = !showMoveList">
                    <i class="fa-solid fa-arrows-up-down-left-right"></i>
                    {{ $t('dash.templates.move-to') }}
                </div>

                <div class="tim-move-list hide-scrollbar" v-if="showMoveList">
                    <div
                        class="tim-move-option"
                        :class="{ active: !currentFolderId }"
                        @click="move(null)"
                    >{{ $t('dash.templates.root') }}</div>
                    <div
                        class="tim-move-option"
                        v-for="folder in folders"
                        :key="folder.id"
                        :class="{ active: folder.id === currentFolderId }"
                        @click="move(folder.id)"
                    >{{ folder.name }}</div>
                </div>
            </template>

            <div class="tim-option tim-danger" @click="emitAndClose('delete')">
                <i class="fa-solid fa-trash"></i>
                {{ $t('dash.templates.delete') }}
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    name: 'TemplateItemMenu',

    directives: { ClickOutside },

    props: {
        folders: {
            type: Array,
            default: () => []
        },
        currentFolderId: {
            type: String,
            default: null
        },
        movable: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            open: false,
            showMoveList: false
        }
    },

    methods: {
        emitAndClose(event) {
            this.$emit(event)
            this.closeMenu()
        },

        move(targetId) {
            this.$emit('move', targetId)
            this.closeMenu()
        },

        closeMenu() {
            this.open = false
            this.showMoveList = false
        }
    }
}
</script>

<style lang="scss" scoped>
.template-item-menu {
    position: relative;

    .tim-trigger {
        color: #aeaeae;
        cursor: pointer;
        padding: 6px;
        font-size: 12px;

        &:hover {
            color: #fff;
        }
    }

    .tim-dropdown {
        position: absolute;
        right: 0;
        top: 100%;
        background: #fff;
        border-radius: 6px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        min-width: 160px;
        z-index: 10;
        padding: 4px;
    }

    .tim-option {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 10px;
        font-size: 12px;
        cursor: pointer;
        border-radius: 4px;
        white-space: nowrap;

        i {
            width: 12px;
            font-size: 11px;
            color: #9ba3b7;
        }

        &:hover {
            background: #f5f6fa;
        }

        &.tim-danger {
            color: #e14e4e;

            i {
                color: #e14e4e;
            }
        }
    }

    .tim-move-list {
        max-height: 160px;
        overflow-y: auto;
        border-top: 1px solid #e3e6ee;
        border-bottom: 1px solid #e3e6ee;
        margin: 2px 0;
    }

    .tim-move-option {
        padding: 6px 10px;
        font-size: 12px;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
            background: #f5f6fa;
        }

        &.active {
            color: #6b1f4d;
            font-weight: 600;
        }
    }
}
</style>
